
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/2023-jobs-report",
      function () {
        return require("private-next-pages/reports/2023-jobs-report.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/2023-jobs-report"])
      });
    }
  